module.exports = __webpack_public_path__ + "media/site_templates/www.electriciannearme.agency/images/our_services_1-c55ba63ed5cf63e9d7351b55ff8755ce.jpg";